export default [
	['/log-in', 'LoginRoute'],
	['/login-third-party', 'LogInThirdParty'],
	['/authorize', 'AuthorizeRoute'],
	['/forgot-password', 'ForgotPassword'],
	['/forgot-password/check-email', 'CheckEmail'],
	['/reset-password', 'ResetPassword'],
	['/reset-password/success', 'ResetPasswordSuccess'],
];
